import { AUTH_LOGIN_GQL } from './gql';
import { apolloClient } from '../client';
import { AuthPayload, LoginInput } from '../types.generated';

export const loginMutation = async (payload: LoginInput): Promise<AuthPayload> => {
  const response = await apolloClient.mutate<{ login }>({
    mutation: AUTH_LOGIN_GQL,
    variables: {
      input: payload,
    },
  });

  return response.data?.login;
};
